var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRetail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7116 14.5344L12.8538 3.91914C12.8369 3.70973 12.662 3.54839 12.4519 3.54839H10.149V3.0379C10.149 1.3628 8.8042 0 7.12904 0H7.07582C5.40071 0 4.02001 1.3628 4.02001 3.0379V3.54839H1.75297C1.54286 3.54839 1.36797 3.70973 1.35103 3.91914L0.490817 14.5643C0.481731 14.6766 0.520011 14.7874 0.596355 14.8702C0.672699 14.9529 0.780226 15 0.892753 15H13.3121C13.3124 15 13.3129 15 13.3132 15C13.5359 15 13.7164 14.8195 13.7164 14.5968C13.7164 14.5755 13.7148 14.5547 13.7116 14.5344ZM4.82646 3.0379C4.82646 1.80747 5.84539 0.806452 7.07582 0.806452H7.12904C8.35947 0.806452 9.34259 1.80747 9.34259 3.0379V3.54839H4.82646V3.0379Z",
    fill: "#6B6B76"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetail);
export default __webpack_public_path__ + "static/media/retail.ad454b4f.svg";
export { ForwardRef as ReactComponent };